'use client';
import { ConnectedStateContext, ToastContext, ConnectionModalOpenContext } from '@/pagesComponents/Layout';
import { logout } from '@/services/home';
import Link from 'next/link';
import { useContext, useEffect, useState } from 'react';
import Button from '@/components/Button';
import { useSession } from 'next-auth/react';
import UserInitials from '@/components/layout/UserInitials';

const ProfileDropdown = ({}) => {
  const [isConnected, setIsConnected] = useContext(ConnectedStateContext);
  const [openConnexionModal, setOpenConnexionModal] = useContext(ConnectionModalOpenContext);
  const updateToast = useContext(ToastContext);
  const [userInitials, setUserInitials] = useState('');
  const [userEmail, setUserEmail] = useState('');
  const [userName, setUserName] = useState('');
  const { data: session } = useSession();

  const closeNavbar = () => {
    const navbarCollapse = document.getElementById('navbarSupportedContent');
    if (navbarCollapse?.classList.contains('show')) {
      navbarCollapse.classList.remove('show');
    }
  };

  useEffect(() => {
    const dropdownButton = document.getElementById('dropdownMenuButton1');
    if (dropdownButton) {
      dropdownButton.addEventListener('show.bs.dropdown', closeNavbar);
      return () => {
        dropdownButton.removeEventListener('show.bs.dropdown', closeNavbar);
      };
    }
  }, []);

  const handleDisconnection = async () => {
    try {
      const result = await logout();
      window.location.href = '/';
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (isConnected) {
      const initials = (
        (session.user.prenom?.charAt(0) || '') + (session.user.nom?.charAt(0) || '')
      ).toUpperCase();
      setUserName(session.user.prenom + ' ' + session.user.nom);
      setUserInitials(initials);
      setUserEmail(session.user.Email);
    }
  }, [isConnected, session]);

  return (
    <div className="profile">
      {!isConnected && (
        <Button
          type="button"
          className="btn btn-primary"
          data-bs-toggle="modal"
          data-bs-target="#login-modal"
          onClick={() => setOpenConnexionModal(true)}
        >
          Connexion
        </Button>
      )}
      {isConnected && (
        <>
          <Button
            className="btn icon-link "
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            onClick={closeNavbar}
          >
            {userInitials?.length > 0 ? (
              <UserInitials userInitials={userInitials} userName={userName} />
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" width="42" height="42" viewBox="0 0 42 42">
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M7.875 36.75C7.875 36.75 5.25 36.75 5.25 34.125C5.25 31.5 7.875 23.625 21 23.625C34.125 23.625 36.75 31.5 36.75 34.125C36.75 36.75 34.125 36.75 34.125 36.75H7.875ZM21 21C23.0886 21 25.0916 20.1703 26.5685 18.6935C28.0453 17.2166 28.875 15.2136 28.875 13.125C28.875 11.0364 28.0453 9.03338 26.5685 7.55653C25.0916 6.07969 23.0886 5.25 21 5.25C18.9114 5.25 16.9084 6.07969 15.4315 7.55653C13.9547 9.03338 13.125 11.0364 13.125 13.125C13.125 15.2136 13.9547 17.2166 15.4315 18.6935C16.9084 20.1703 18.9114 21 21 21Z"
                  fill="#54595E"
                />
              </svg>
            )}
          </Button>
          <ul className="dropdown-menu dropdown-menu-end px-3" aria-labelledby="dropdownMenuButton1">
            <li>
              <span>{userEmail}</span>
            </li>
            <li>
              <Link className="dropdown-item" href="/profile">
                Mon Profil
              </Link>
            </li>
            <li>
              <Button className="dropdown-item" onClick={handleDisconnection}>
                Déconnexion
              </Button>
            </li>
          </ul>
        </>
      )}
    </div>
  );
};

export default ProfileDropdown;
